<template>
  <v-dialog v-model="dialog" width="900">
    <template v-slot:activator="{ on, attrs }">
      <div v-if="user.user_agreement_confirmed === 0 && !user.user_agreement_is_current">-</div>
      <div
        v-else-if="user.user_agreement_confirmed === 1 && user.user_agreement_is_current"
        :vBind="attrs"
        :vOn="on"
        @click="openModal"
        class="iconBtn"
      >
        <IconAccess />
      </div>
      <div
        v-else-if="user.user_agreement_confirmed === 1 && !user.user_agreement_is_current"
        :vBind="attrs"
        :vOn="on"
        @click="openModal"
        class="iconBtn"
      >
        <IconAccess style="filter: grayscale(100%)" />
      </div>
      <div
        v-else-if="user.user_agreement_confirmed === 0 && user.user_agreement_is_current"
        :vBind="attrs"
        :vOn="on"
        @click="openModal"
        class="iconBtn"
      >
        <IconAccessNo />
      </div>
    </template>
    <transition :duration="150">
      <div class="edit" v-if="dialog">
        <CloseModalBtn :closeModal="closeModal" />
        <h5>
          {{
            this.localStorage.translations.pages.setting.pages.offer_agreement +
            ' ' +
            user.first_name +
            ' ' +
            user.last_name
          }}
        </h5>
        <div class="content">
          <transition name="fade" mode="out-in" appear>
            <LoadingAnimation v-if="loading" />
            <v-simple-table v-else-if="!loading && data.length" class="table">
              <thead>
                <tr>
                  <th class="text-left">
                    {{ localStorage.translations.pages['setting-offer_agreement'].tables.name }}
                  </th>
                  <th class="text-left">
                    {{
                      localStorage.translations.pages['setting-offer_agreement'].tables
                        .date_time_confirm
                    }}
                  </th>
                  <th class="text-left">
                    {{ localStorage.translations.pages['setting-offer_agreement'].tables.language }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(offer, key) in data" :key="key">
                  <td>
                    {{ offer.agreement.name }}
                  </td>
                  <td>
                    {{ offer.signed_at ? formatDate(offer.signed_at) : '-' }}
                  </td>
                  <td>
                    <div v-if="offer.language_id" class="flag">
                      <img :key="key" :src="findObject(offer.language_id).image.svg" alt="flag" />
                    </div>
                    <div v-else>-</div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
            <Plug v-else-if="!loading && !data.length" />
          </transition>
        </div>
      </div>
    </transition>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import IconAccess from 'components/icons/IconAccess'
import IconAccessNo from 'components/icons/IconAccessNo'
import CloseModalBtn from 'components/CloseModalBtn'
import LoadingAnimation from 'components/LoadingAnimation'
import Plug from 'components/Plug'

export default {
  name: 'UserOfferAgreementHistoryModal',
  components: {
    CloseModalBtn,
    IconAccess,
    IconAccessNo,
    LoadingAnimation,
    Plug,
  },
  props: ['id', 'name', 'user'],
  data() {
    return {
      dialog: false,
      data: [],
      loading: true,
    }
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.onUserHistory()
      }
    },
  },
  computed: {
    ...mapGetters(['apiDomain']),
    ...mapGetters('languages', ['languages']),
  },
  methods: {
    ...mapActions('offerAgreement', ['onOfferAgreementUserHistory']),
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
    formatDate(date) {
      if (!date) return null
      const [dateOnly, time] = date.split(' ')
      const [year, month, day] = dateOnly.split('-')
      return `${day}.${month}.${year}` + ' ' + time
    },
    onUserHistory() {
      this.loading = true
      this.onOfferAgreementUserHistory(this.user.id)
        .then((response) => {
          this.data = response
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    },
    findObject(id) {
      const key = Object.keys(this.languages).filter((i) => this.languages[i].id == id)
      return this.languages[key]
    },
  },
}
</script>

<style lang="scss" scoped>
.iconBtn {
  display: block;
  cursor: pointer;
  width: max-content;
  height: max-content;
  line-height: 0;
}
.edit:deep() {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  // text-align: center;
  padding: 30px;
  position: relative;
  .close {
    padding: 16px;
  }

  h5 {
    text-align: center;
    margin-bottom: 20px;
  }
  .content {
    min-height: 50px;
    position: relative;
  }
  .table {
    width: 100%;
    box-shadow: 0px 6px 18px rgba(0, 0, 0, 0.06);
    .v-data-table__wrapper {
      overflow: visible;
    }
    thead {
      background: #e4f3fb;
    }
    tr {
      th {
        font-weight: 500;
        color: #2c2c2c !important;
      }
      td {
        .flag {
          img {
            object-fit: cover;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            border: 1px solid #e4f3fb;
          }
        }
      }

      th,
      td {
        &:first-of-type {
          width: auto;
          padding-left: 30px !important;
        }
        &:last-of-type {
          width: auto;
          padding-right: 40px !important;
          path {
            &:hover {
              fill: #ec1b0e;
            }
          }
        }
      }
    }
  }
  p {
    margin-bottom: 30px;
  }
}
</style>
